import { getUnitColor } from '../utils';

export default function useIndexColor(index?: number) {
  return getUnitColor(index && index > 0 ? index - 1 : 0);
}
